import { IApplicationState } from 'reduxStore/types';

export const getCurrentPlace = (state: IApplicationState) => state.currentAddress;

export const getCurrentPlaceName = (state: IApplicationState) => {
  const currentAddress = getCurrentPlace(state);
  return currentAddress.name;
};
